<div class="inner-page-header">
  <h3>تعديل بيانات الوحدة</h3>
</div>

@if (propertyUnitDetails) {
<form [formGroup]="propertyUnitFormGroup">
  <div class="main-card">
    <div class="row">
      <div class="col-md-6 form-group">
        <label for="" class="form-label">
          اسم العميل
          <span class="red">*</span>
        </label>
        <input type="text" readonly class="form-control" formControlName="client_name"
          placeholder="يرجى كتابة اسم العميل" />
      </div>
      <div class="col-12 property-unit-section form-group">
        <div class="custom-label">
          <img src="assets/images/svg/user.svg" class="label-icon" alt="user">
          <label class="form-label">
            العلاقة بالعقار <span class="optional"> (اختياري)</span>
          </label>
        </div>
        <div class="relation-options">
          @for(option of relationOptions; track option.id) {
          <label class="relation-option" [class.active]="isSelected(option.id)">
            <input type="checkbox" [value]="option.id" [checked]="isSelected(option.id)"
              (change)="toggleRelation(option.id)" class="checkbox-input">
            <span class="checkbox-icon"></span>
            <span class="option-label">{{ option.name }}</span>
          </label>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="main-card mt-2">
    <div class="col-12 property-unit-section form-group">
      <div class="custom-label">
        <img src="assets/images/svg/location.svg" class="label-icon" alt="location">
        <label class="form-label">
          تحديد موقع العقار<span class="red">*</span>
        </label>
      </div>
      <property-unit-location [unitDetails]="propertyUnitDetails"
        [propertyDetailsFormGroup]="propertyUnitFormGroup"></property-unit-location>
    </div>
  </div>

  <div class="main-card mt-2">
    <div class="col-12 property-unit-section form-group">
      <div class="custom-label">
        <img src="assets/images/svg/building.svg" class="label-icon" alt="building">
        <label class="form-label">
          تفاصيل العقار<span class="red">*</span>
        </label>
      </div>
      <unit-details [unitDetails]="propertyUnitDetails"
        [propertyDetailsFormGroup]="propertyUnitFormGroup"></unit-details>
    </div>
  </div>

  <div class="main-card mt-2">
    <div class="col-12 property-unit-section form-group">
      <div class="custom-label">
        <img src="assets/images/svg/building1.svg" class="label-icon" alt="building">
        <label class="form-label">
          ملفات العقار<span class="optional"> (اختياري)</span>
        </label>
        <button class="btn btn-add" (click)="addAddFileInput()">
          <img src="assets/images/svg/add-icon.svg" alt="">
          أضف ملف آخر
        </button>
      </div>
      @if (fileError) {
      <div class="alert-box mb-3">
        <img src="assets/images/svg/error-icon.svg" class="close-alert" (click)="fileError = null" alt="" />
        <p class="alert-msg">{{ fileError }}</p>
      </div>
      } @else if (propertyFiles.length === 0) {
      <p class="no-files-msg">لا توجد ملفات مرفقة لهذه الوحدة.</p>
      } @else {
      <div class="row">
        @for (file of propertyFiles; track file.id; let i = $index) {
        <div class="col-md-6">
          <file-input [file]="file" [fileIndex]="i" [fileLabel]="'fileLabel'" [fileName]="'name'"
            (save)="handleFile($event, i, file.is_predefined)" (delete)="deleteFile(file, i)">
          </file-input>
        </div>
        }
      </div>
      }
    </div>
  </div>

  @if (errorMsg) {
  <div class="alert-box m-3">
    <img src="assets/images/svg/error-icon.svg" class="close-alert" (click)="closeError()" alt="" />
    <p class="alert-msg">{{ message }}</p>
  </div>
  }

  <div class="double-action mt-3">
    <a class="btn btn-grey" [routerLink]="'/pages/property-units/' + unitId">السابق</a>
    <app-action-button [label]="'حفظ'" (submitAction)="save($event)"></app-action-button>
  </div>
</form>
}
